export default "__VITE_ASSET__By2rwvIi__"